import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
  path: '/xy/mini-app',
  name: 'xy-mini-app',
  meta,
  redirect: { name: 'xy-mini-app-goodsInf' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'dictItem', name: `${pre}dictItem`, component: _import('xy/mini-app/dictItem'), meta: { ...meta, cache: true, title: '字典项管理' } },
    { path: 'indexImg', name: `${pre}indexImg`, component: _import('xy/mini-app/indexImg'), meta: { ...meta, title: '首页轮播图管理' } },
    { path: 'goodsInf', name: `${pre}goodsInf`, component: _import('xy/mini-app/goodsInf'), meta: { ...meta, cache: true, title: '药品信息管理' } },
    { path: 'article', name: `${pre}article`, component: _import('xy/mini-app/article'), meta: { ...meta, cache: true, title: '用药指导管理' } },
    { path: 'cancer', name: `${pre}cancer`, component: _import('xy/mini-app/cancer'), meta: { ...meta, cache: true, title: '疾病管理' } },
    { path: 'userList', name: `${pre}userList`, component: _import('xy/mini-app/userList'), meta: { ...meta, cache: true, title: '注册用户管理' } },
    { path: 'assessment', name: `${pre}assessment`, component: _import('xy/mini-app/assessment'), meta: { ...meta, cache: true, title: '问卷管理' } },
    { path: 'userAssessment', name: `${pre}userAssessment`, component: _import('xy/mini-app/userAssessment'), meta: { ...meta, cache: true, title: '填报列表' } },
    { path: 'identityAudit', name: `${pre}identityAudit`, component: _import('xy/mini-app/identityAudit'), meta: { ...meta, cache: true, title: '身份审核' } },
    { path: 'hospital', name: `${pre}hospital`, component: _import('xy/mini-app/hospital'), meta: { ...meta, cache: true, title: '医院科室管理' } },
    { path: 'group', name: `${pre}group`, component: _import('xy/mini-app/group'), meta: { ...meta, cache: true, title: '群组管理' } }
  ])('xy-mini-app-')
}
